"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressFields = exports.AddressFields = exports.getAddressPlaceholder = exports.getPhonePlaceHolder = exports.getSupportNumber = exports.getBusinessIdentifierType = void 0;
function getBusinessIdentifierType(countryCode) {
    switch (countryCode) {
        case 'GB':
            return 'VAT';
        case 'AU':
            return 'ABN';
        case 'NZ':
            return 'NZBN';
        case 'IE':
            return 'VAT';
        case 'ES':
            return 'VAT';
        case 'US':
            return undefined;
        default:
            return 'ABN';
    }
}
exports.getBusinessIdentifierType = getBusinessIdentifierType;
function getSupportNumber(countryCode) {
    switch (countryCode) {
        case 'GB':
            return '0330 822 5485';
        case 'AU':
            return '1300 166 546';
        case 'NZ':
            return '09 870 4200';
        default:
            return '1300 166 546';
    }
}
exports.getSupportNumber = getSupportNumber;
function getPhonePlaceHolder(countryCode) {
    switch (countryCode) {
        case 'AU':
            return '0423 456 789';
        case 'GB':
            return '7700 900 123';
        case 'NZ':
            return '02 345 6789';
        case 'US':
            return '555 555 2345';
        default:
            return '0423 456 789';
    }
}
exports.getPhonePlaceHolder = getPhonePlaceHolder;
function getAddressPlaceholder(countryCode) {
    switch (countryCode) {
        case 'AU':
            return '123 Example St, Melbourne VIC 3000, Australia.';
        case 'GB':
            return '7 Nine Elms Lane, London SW8 5PH, United Kingdom.';
        case 'NZ':
            return '204 Newsome Street, Penrose, Auckland, 1061, New Zealand.';
        case 'US':
            return '21990 Village View Drive, Fort Myers, Florida, 33901, United States.';
        case 'IE':
            return '10 Knockpogue pk, Balbriggan, Dublin, D01 F5P2, Ireland.';
        case 'ESP':
            return 'Atamaria 4, Manlleu, Barcelona, 08560, Spain.';
        default:
            return '123 Example St, Melbourne VIC 3000, Australia.';
    }
}
exports.getAddressPlaceholder = getAddressPlaceholder;
var AddressFields;
(function (AddressFields) {
    AddressFields["SEARCH"] = "search";
    AddressFields["LINE1"] = "line1";
    AddressFields["LINE2"] = "line2";
    AddressFields["SUBURB"] = "suburb";
    AddressFields["CITY"] = "city";
    AddressFields["STATE"] = "state";
    AddressFields["COUNTY"] = "county";
    AddressFields["CODE"] = "postalCode";
    AddressFields["COUNTRY"] = "country";
})(AddressFields = exports.AddressFields || (exports.AddressFields = {}));
function getAddressFields(countryCode) {
    const { LINE1, LINE2, SUBURB, CITY, STATE, COUNTY, CODE, COUNTRY, SEARCH } = AddressFields;
    switch (countryCode) {
        case 'AU':
            return [SEARCH, LINE1, LINE2, SUBURB, STATE, CODE, COUNTRY];
        case 'GB':
            return [SEARCH, LINE1, LINE2, COUNTY, CODE, COUNTRY];
        case 'NZ':
            return [SEARCH, LINE1, LINE2, SUBURB, CITY, CODE, COUNTRY];
        case 'US':
            return [SEARCH, LINE1, LINE2, CITY, STATE, CODE, COUNTRY];
        case 'IE':
            return [SEARCH, LINE1, LINE2, CITY, CODE, COUNTRY];
        case 'ESP':
            return [SEARCH, LINE1, LINE2, CODE, CITY, COUNTRY];
        default:
            return [SEARCH, LINE1, LINE2, SUBURB, STATE, CODE, COUNTRY];
    }
}
exports.getAddressFields = getAddressFields;
//# sourceMappingURL=contact.js.map